import { RefDate, RefNumber } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { ManaPostalDeliveryStepRawData } from "./ManaPostalDeliveryStepRawData";
import { ManaPostalDeliveryStepState } from "./ManaPostalDeliveryStepState";


export class ManaPostalDeliveryStepData extends StepData
{
    public DeliveryDeadline = new RefDate(new Date(0));
    public Amount = new RefNumber(0);
    public DeliveryTime = new RefDate(new Date(0));

    constructor(raw: Partial<ManaPostalDeliveryStepRawData>)
    {
        super(raw);

        this.State.value ||= ManaPostalDeliveryStepState.Awaiting;

        this.DeliveryDeadline.value = this.GetDate(raw?.DeliveryDeadline);
        this.Amount.value = this.GetNumber(raw?.Amount);
        this.DeliveryTime.value = this.GetDate(raw?.DeliveryTime);
    }
}
